import { Component, ElementRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, startWith } from 'rxjs/operators';

@Component({
  selector: 'quick-search',
  templateUrl: './quick-search.component.html',
  styleUrls: ['./quick-search.component.scss']
})
export class QuickSearchComponent implements OnInit {
  @Input() placeholder: string = 'البحث...';
  searchSubject = new Subject();
  
  @ViewChild('searchInput', { static: true }) input: ElementRef;
  
  @Output() searchResults = this.searchSubject.pipe(
    debounceTime(1),
    distinctUntilChanged()
  );
  
 constructor(private route: ActivatedRoute){}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const query = params['query'];
      if (query) {
        this.input.nativeElement.value = query;
        this.doSearch();
      }
    });
  }

  handleEmptyValue() {
    if(!this.query) {
      this.getDefaultData();
    }
  }

  getDefaultData() {
     this.searchSubject.next(null);
  }

  doSearch() {
    this.searchSubject.next(this.query);
  }

  private get query() { 
    return this.input.nativeElement.value.trim(); 
  }

}
